import React from 'react';
import { Send } from '../common/IconsComponent';

const SendCodeButton = ({ onSendCode, name }) => (
  <button
    type="button"
    onClick={() => onSendCode(name)}
    className="inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-600 text-xs font-medium px-2.5 py-1.5 rounded-full hover:bg-indigo-100 transition-colors shadow-sm"
  >
    שלח קוד
    <Send size={11} />
  </button>
);

export default SendCodeButton;